import axios from 'axios';
import process from "shelljs";
import authHeader from "./auth-header";

const API_URL = process.env.BFF_URL + "/auth/";

class AuthService {
  login(user) {
    return axios
      .post(API_URL + 'login', {
        username: user.username,
        password: user.password
      })
      .then(response => {
        if (response.data.success) {
          localStorage.setItem('user', JSON.stringify(response.data.data));
        }
        return response.data.data;
      })
      .catch(error => {
        console.log("Error: ", error.response.data)
        return error.response.data
      })
  }

  logout() {
    localStorage.removeItem('user');
    localStorage.removeItem('mid');
    localStorage.removeItem('perms');
    localStorage.removeItem('permissions');
    localStorage.removeItem('homeUrl');
    localStorage.clear()
  }

  register(user) {
    return axios.post(API_URL + 'register', {
      username: user.username,
      email: user.email,
      password: user.password
    });
  }
}

export default new AuthService();



// WEBPACK FOOTER //
// ./src/service/auth.service.js